import { isUndNullEmpNew } from '../../helpers/UtilsHelper';

export class ResponseClass {
    constructor(
        msgType = 0,
        isSuccess = true,
        isWarning = false,
        msgText = '',
        msgTextHtml = '',
        result = undefined,
        urlGoTo = '',
        record = {
            delete: false,
            notFound: false,
        },
    ) {
        this.isSuccess = isSuccess;
        this.isWarning = isWarning;
        this.msgType = msgType;
        this.msgText = msgText;
        this.msgTextHtml = msgTextHtml;
        this.result = result;
        this.urlGoTo = urlGoTo;
        this.record = record;
    }

    getClassName = () => {
        return 'Response - class';
    }

    getClass = (obj = Object) => {
        if (!isUndNullEmpNew({ data: obj, subMethod: this.getClassName(), })?.result) {
            return new ResponseClass(
                obj?.isSuccess,
                obj?.isWarning,
                obj?.msgType,
                obj?.msgText,
                obj?.msgTextHtml,
                obj?.result,
                obj?.urlGoTo,
                obj?.record,
            );
        } else {
            return new ResponseClass();
        }
    }

    getClassIsWarning = () => {
        return new ResponseClass(1, true, true, '', '', undefined, '', { delete: false, notFound: false });
    }
}